import React from 'react';
//Importamos los componentes que usaremos de la libreria de react-beatiful-dnd
import { Droppable, Draggable } from "react-beautiful-dnd";


export default function Casilla(props) {
    //Traemos en props el estado establecido en el componente app que vamos a usar para renderizar en pantalla las diferentes casillas.
    let casillasEstado = props.listaFichos;
    //pasamos a una variable el prop traido de el componente app en este caso el droppable id que es el id de cada dropable que se genera al rendereizar este componente.
    let droppableId = props.droppableId;

    return (
        <Droppable droppableId={props.droppableId}>
        {/*Traemos los componentes de la libreria dnd droppable y draggable y les pasamos sus respectivos parametros despues mapeamos la lista en este caso usamos props para que mapee la lista respectiva al componente y a la casilla en cuestion. */}
            {(provided) => (
                <ul
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className={props.casilla}
                >
                    {
                        casillasEstado[droppableId].map((casilla, index) => (
                            <Draggable key={casilla.id} draggableId={casilla.id} index={index}>
                                {
                                    (provided) => (
                                        <li
                                            {...provided.draggableProps}
                                            ref={provided.innerRef}
                                            {...provided.dragHandleProps}
                                            className="ficho__li"
                                        >
                                            {/* {casilla.img} */}
                                            {/*Dentro de la etiqueta li ponemos una imagne en este caso la imagen del ficho y en SRC pasamos el parametro que tenemos guardado en la lista que tenemos en lib y que mapeamos */}
                                            <img className="ficho__img" src={casilla.img} alt={`imagen-${casilla.id}`}/>
                                        </li>
                                    )}
                            </Draggable>
                        ))
                    }
                    {provided.placeholder}
                </ul>
            )}
        </Droppable>
    )
}
